<template>
  <div class="login-page">
    <div class="bloc-connexion">
      <div cols="12" class="bloc-connexion__content">
          <v-col class="image-placeholder">
              <h1 class="text text-uppercase display-2 font-weight-bold">
                Bienvenue sur
              </h1>
              <div>
                <v-img
                class="my-5"
                src="/static/images/logo-spideup-white.png"
                width="300"
              ></v-img>
              </div>
              <p class="text text-login">
                Bienvenue sur la plateforme SpideUp, votre solution de mesure
                et de création de trafic dans votre point de vente
              </p>
              <p class="text text-login">
                Le meilleur de l'intéraction mobile pour votre clilentèle !
              </p>
              <v-row class="footer">
                <v-img class="white--text pl-2 pb-1">1G-Link © 2023</v-img>
              </v-row>
          </v-col>

          <v-col class="login-params">
            <v-row
              class="text weight-bold size-xlarge mb-5"
              style="word-break: break-word"
            >
              <strong>Lien de réinitialisation envoyé</strong>
            </v-row>

            <v-row>
              <div class="pb-3">
                Nous avons envoyé un mail à l'adresse suivante:
                <a class="userMail">{{ email }}</a
                >.
              </div>
              <div class="pb-3">
                Pour créer un nouveau mot de passe, cliquez sur le lien contenu
                dans l'email et tapez-en un nouveau : c'est facile !
              </div>
              <div class="pb-3">
                E-mail non reçu ? Vérifiez vos courriers indésirables ou
                demandez un nouvel envoi
              </div>
            </v-row>

            <v-row class="py-6">
              <v-col cols="6">
                <customButton
                  class="customBtn"
                  label="Envoyer à nouveau"
                  btnType="sendMail"
                  labelColor="pink"
                  :elevation="0"
                />
              </v-col>
              <v-col cols="6">
                <customButton
                  class="customBtn"
                  label="Connexion"
                  btnType="connexion"
                  :elevation="0"
                  @click="Login"
                />
              </v-col>
            </v-row>
          </v-col>


      </div>
    </div>
  </div>
</template>


<script type="text/javascript">
import TextInput from "@/components/input/textInput";
import CheckBox from "@/components/input/checkboxInput.vue";
import customButton from "@/components/buttons/customButton.vue";
import LoginInput from "@/components/input/loginInput";

export default {
  components: {
    CheckBox,
    TextInput,
    customButton,
    LoginInput,
  },
  props: {},
  data() {
    return {
      email: null,
    };
  },
  methods: {
    Login() {
      const params = {
        email: this.email,
        password: this.password,
        error: () => {
          this.$store.commit(
            "ui/triggerAlert",
            { type: "error", msg: "Connexion échoué" },
            { root: true }
          );
        },

        success: () => {
          this.$store.commit(
            "ui/triggerAlert",
            { type: "success", msg: "Connexion réussie avec succès" },
            { root: true }
          );
          this.$router.push({ name: "DashboardV2" });
        },
      };

      this.$store.dispatch("auth/login", params);
    },
  },
  created() {
    // si pas d'email redirection demande de reset de password
    this.email = this.$router.currentRoute.params.email;
    document.body.querySelector(".v-main__wrap").style.backgroundColor =
      "#fd5d5c";
  },
  computed: {},
};
</script>
